import { useApp } from "@next-platform/client-common-core";
import { Chip, Spacer } from "@nextui-org/react";

import { LocalizedLink } from "@/components";
import { Row, Text } from "@/components/customComponents";
import Trans from "@/components/Trans/Trans";

interface IYourBenefitsProps {
  permissionsToDisplay: string[];
}

export const YourBenefits = ({ permissionsToDisplay }: IYourBenefitsProps) => {
  const { branding } = useApp();
  return (
    <>
      <Spacer y={3} />
      <Text b>
        <Trans i18nKey="user:profile.benefits.title" />
      </Text>
      <LocalizedLink className="text-[12px] ml-5 text-link" to={branding?.customerSupportUrl || ""} aria-label="not-as-expected">
        <Trans i18nKey="user:profile.benefits.notAsExpected" />
      </LocalizedLink>
      <Spacer y={1} />
      <Row className="gap-1 flex-wrap">
        {permissionsToDisplay.map((item, index) => {
          if (item === "site_access") {
            return true;
          }
          return (
            <Chip
              key={index}
              classNames={{
                base: "h-6 px-0",
                content: "capitalize font-bold text-xs text-white",
              }}
              color="secondary"
            >
              {item.replaceAll("_", " ")}
            </Chip>
          );
        })}
      </Row>
      <Spacer y={1} />
    </>
  );
};
